import axios from 'axios';
import { getAuthToken } from './authToken';

declare module 'axios' {
  interface AxiosRequestConfig {
    fsSessionToken?: string | null;
  }
}

const Axios = axios.create();

Axios.interceptors.request.use((config) => {
  config.baseURL = process.env.API_BASE_URL;
  const token =
    config.fsSessionToken !== undefined
      ? config.fsSessionToken
      : getAuthToken();
  // 排队的会话写入已绑定发起者的 token，不能在异步拦截器里换成新账号
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default Axios;
